export const validateProdStatementFilters = (data: any, errors: any) => {
  let isValid = true;

  if (!data.fromDate) {
    errors = { ...errors, fromDate: 'From date is required' };
    isValid = false;
  } else {
    delete errors.fromDate;
  }

  if (!data.toDate) {
    errors = { ...errors, toDate: 'To Date is required' };
    isValid = false;
  } else {
    delete errors.toDate;
  }

  if (!data.allProducts && !data.product) {
    errors = { ...errors, product: 'At least one product should be selected' };
    isValid = false;
  } else {
    delete errors.product;
  }

  return { isValid, errs: errors };
};
